import { motion } from "framer-motion";
import { Instagram as InstagramIcon } from "lucide-react";

export default function FinalCTA() {
  return (
    <section className="relative section-pad" data-testid="final-cta-section">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1 }}
          className="relative overflow-hidden rounded-3xl glass-gold p-10 md:p-16 lg:p-20 text-center glow-gold"
        >
          {/* glow orbs */}
          <div className="absolute -top-20 -left-20 w-80 h-80 bg-gold/15 blur-[120px] rounded-full" />
          <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-rose/15 blur-[120px] rounded-full" />

          {/* texture */}
          <div
            className="absolute inset-0 opacity-30 mix-blend-overlay pointer-events-none"
            style={{
              backgroundImage:
                "url(https://static.prod-images.emergentagent.com/jobs/f5b37ca2-a67c-4e64-8610-b14663f65188/images/6fd1ecf108593a0b71fa50719fd3d57844f47927982be09e9f40678edab8c45d.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />

          <div className="relative">
            <div className="flex items-center justify-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="text-xs uppercase tracking-[0.3em] text-gold font-medium">
                Let's Begin
              </span>
              <span className="h-px w-10 bg-gold" />
            </div>
            <h2
              className="font-serif font-light text-4xl sm:text-5xl lg:text-7xl leading-[1.02] tracking-tight"
              data-testid="final-cta-heading"
            >
              Let's create an event
              <br />
              to <span className="italic text-gold-gradient">remember.</span>
            </h2>
            <p className="mt-8 text-ivory/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed font-light">
              From intimate gatherings to grand celebrations, Shree Event Planner brings your
              vision to life with thoughtful planning, creative styling, and seamless execution.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 items-stretch sm:items-center justify-center flex-wrap max-w-md sm:max-w-none mx-auto">
              <a href="#contact" className="btn-gold text-center" data-testid="final-cta-button">
                Get in Touch
              </a>
              <a
                href="https://www.instagram.com/mayankpatel2686/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-ghost-gold inline-flex items-center justify-center gap-2 text-center"
                data-testid="final-cta-instagram"
              >
                <InstagramIcon size={16} /> Follow on Instagram
              </a>
              <a
                href="mailto:contact@shreeeventplanner.com"
                className="btn-ghost-gold text-center break-all sm:break-normal"
                data-testid="final-cta-email"
              >
                contact@shreeeventplanner.com
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
